import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [
  // Navigate Menu
  nativeCommsMessageTypes.SELECT_NEXT_ITEM,
  nativeCommsMessageTypes.SELECT_PREVIOUS_ITEM,
  nativeCommsMessageTypes.SELECT_ALL_BEFORE_CURRENT_SELECTION,
  nativeCommsMessageTypes.SELECT_ALL_AFTER_CURRENT_SELECTION,
  nativeCommsMessageTypes.SCROLL_TO_SELECTION,
  // Timeline Menu
  nativeCommsMessageTypes.REMOVE_FROM_VIEW,
  nativeCommsMessageTypes.PERMANENT_DELETE,
  nativeCommsMessageTypes.SHIFT_ITEMS_BY,
  nativeCommsMessageTypes.MAKE_CONSECUTIVE,
  nativeCommsMessageTypes.MAKE_DEPENDENT,
  nativeCommsMessageTypes.REMOVE_DEPENDENCIES,
  nativeCommsMessageTypes.EMBED_IN_NEW_PARENT,
  nativeCommsMessageTypes.EMBED_IN_NARRATIVE_FOLDER,
  // View Menu
  nativeCommsMessageTypes.EXPAND_PARENT_ITEM,
  nativeCommsMessageTypes.COLLAPSE_PARENT_ITEM
];
